import { Trans, useTranslation } from 'react-i18next';
import styles from './TableSummary.module.scss';
import Skeleton from 'react-loading-skeleton';
import { useAppSelector } from '@casops/store/hooks';
import { ModelName } from '@casops/store/api';
import { VdsIcon, VdsTooltip } from '@volt/volt-extended-components-react';

export interface TableSummaryProps {
  modelName: ModelName;
  secondaryModelName?: string;
  countAll?: number;
  apiResultLimit?: number;
}

export function TableSummary({
  modelName,
  countAll,
  secondaryModelName,
  apiResultLimit,
}: TableSummaryProps) {
  const dateTimeFormat = useAppSelector(state => state.settings.localization.dateTimeNumberFormat);
  const { t } = useTranslation();

  const isDataLoaded = typeof countAll === 'number';

  return (
    <div className={styles.tableSummary}>
      <div className={styles.tableSummary__text}>
        {isDataLoaded ? (
          <Trans
            i18nKey={'Model.Collection.Summary'}
            values={{ count: countAll, modelName: secondaryModelName ?? modelName }}
            components={{ b: <strong /> }}
            tOptions={{ formatParams: { count: { lng: dateTimeFormat } } }}
          />
        ) : (
          <Skeleton width={150} height="22px" />
        )}
      </div>
      {isDataLoaded && apiResultLimit && (
        <VdsTooltip
          id="table-limit-tooltip"
          event="hover"
          max-width="200px"
          position="right"
          type="standard"
          text={t('ShowingLimitedResults', { limit: apiResultLimit })}
        >
          <VdsIcon
            slot="tooltip-trigger"
            svgIcon="information"
            size="18px"
            color="color-icon-medium"
          />
        </VdsTooltip>
      )}
    </div>
  );
}

export default TableSummary;
